import React, { useRef } from 'react'
import SwiperCore, { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ArrowLeft, ArrowRight } from '@next-nx/shared-ui/icons'
import { WContainer, Button } from '@next-nx/shared-ui/atoms'
import { ArticoloCard } from '@next-nx/shared-ui/molecules'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './NewsSection.module.sass'
import { NewsType } from '@next-nx/utils/types'

SwiperCore.use([Pagination, Navigation])

interface Props {
  variant?: 'variant1' | 'variant2'
  titolo?: string
  ctaLabel?: string
  url?: string
  news: NewsType[]
  className?: string
}

const NewsSection = (props: Props) => {

  const {
    variant = 'variant1',
    titolo = '',
    ctaLabel = '',
    url = '',
    news = [],
    className = '',
  } = props

  const navigationPrevRef = useRef(null)
  const navigationNextRef = useRef(null)
  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type?: string, c?: string, t?: string, cta?: string) => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'navigazione',
      action_tech: 'click',
      action_type: cta?.replace(/ /g, '_').toLowerCase(),
      action_timestamp,
      action_effect: 'interazione_componente_news',
    })
  }

  return news.length ? (
    <div className={`${styles.newsSection} ${styles[`newsSection--${variant}`]} ${className}`}>
      <WContainer variant="md">
        {(titolo || ctaLabel) && (
          <div className={styles.head}>
            {!!titolo && <div className={styles.title} dangerouslySetInnerHTML={{ __html: titolo }} />}
            {variant === "variant1" && (
                ctaLabel && (
                  <div className={styles.ctaBox}>
                    <Button
                      label={ctaLabel}
                      href={url}
                      variant="ghost"
                      icon={<ArrowRight />}
                      iconPos="right"
                      className={styles.ctaDesktop}
                      handleTracking={handleTracking}
                    />
                  </div>
                )
            )}
          </div>
        )}
        
        <div className={styles.slider}>
          <button role="button" id="news-section-prev" ref={navigationPrevRef} className={`${styles.nav} ${styles['nav--prev']}`}>
            <ArrowLeft />
          </button>
          <button role="button" id="news-section-next" ref={navigationNextRef} className={`${styles.nav} ${styles['nav--next']}`}>
            <ArrowRight />
          </button>
          <Swiper
            slidesPerView={1.25}
            spaceBetween={30}
            pagination={{ clickable: true }}
            navigation={{
              prevEl: '#news-section-prev',
              nextEl: "#news-section-next",
            }}
            watchOverflow
            centerInsufficientSlides
            breakpoints={{
              768: {
                slidesPerView: 3,
              },
              576: {
                slidesPerView: 1.25,
              },
            }}
          >
            {news.map((child) => (
              <SwiperSlide key={child.pk}>
                <div className={styles.item}>
                  <ArticoloCard news={child} withDataPubblicazione />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {variant === "variant1" && (
          ctaLabel && (
            <div className={styles.ctaBox}>
              <Button
                label={ctaLabel}
                href={url}
                variant="ghost"
                icon={<ArrowRight />}
                iconPos="right"
                className={styles.ctaMobile}
              />
            </div>
          )
        )}
        {variant === "variant2" && (
          ctaLabel && (
            <div className={styles.ctaBox}>
              <Button
                label={ctaLabel}
                href={url}
                variant="ghost"
                icon={<ArrowLeft />}
                iconPos="left"
              />
            </div>
          )
        )}
      </WContainer>
    </div>
  ) : <></>
}

export default NewsSection
